import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import {
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { FocusTrapModule } from 'primeng/focustrap';

@Component({
  selector: 'app-confirm-unsaved-changes',
  standalone: true,
  templateUrl: './confirm-unsaved-changes.component.html',
  styleUrls: ['./confirm-unsaved-changes.component.scss'],
  imports: [
    CommonModule,
    DynamicDialogModule,
    ButtonModule,
    TranslateModule,
    AutoFocusModule,
    FocusTrapModule,
  ],
})
export class ConfirmUnsavedChangesComponent {
  title: string;
  message: string;
  confirmButton: string;
  cancelButton: string;
  hideMessage: boolean;
  customMessageTranslated: string;
  isGeneralMessage = true;
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
  ) {
    const data = this.config.data;
    this.title = data?.title ?? 'base.messages.UNSAVED_CHANGES_TITLE';
    this.message = data?.message ?? 'base.messages.UNSAVED_CHANGES_MSG';
    this.confirmButton = data?.confirm ?? 'base.actions.LEAVE';
    this.cancelButton = data?.cancel ?? 'base.actions.STAY';
    this.hideMessage = data?.hideMessage || false;
    this.isGeneralMessage = !data?.customMessageTranslated;
    this.customMessageTranslated = data?.customMessageTranslated;
  }

  close(confirmed: boolean): void {
    this.ref.close(confirmed);
  }
}
